import { Tooltip } from '@systemeio/ui'
import { ClickLinkTypeEnum } from 'modules/mailing/email-statistics/enums/click-link-type-enum'
import React from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import { ClickLinkStatisticsInterface } from '../types/email-click-link-statistics'
import { getPercentAndAmountStatistic } from 'shared/utils/get-percent-and-amount-statistic'

export const emailClickLinkStatisticsTableColumns = ({
  t,
  totalClicksForTheEmail,
  mailingId,
}: {
  t: TLocoType
  totalClicksForTheEmail: number
  mailingId: number
}): ColumnDefinitionInterface<ClickLinkStatisticsInterface>[] => {
  return [
    {
      key: 'link',
      header: t('dashboard.email_statistics.table_links.headers.url'),
      widthPercent: 70,
      onRender: statistics => (
        <Tooltip
          label={<div className="max-w-[250px] break-all lg:max-w-[450px]">{statistics.link}</div>}
          mode={'hover'}
          stayOnHover
        >
          <div className={'flex gap-1 pr-0.5'}>
            <LinkWithoutPrefetch
              className="primary-link block w-full truncate"
              href={`/mailing/${mailingId}/statistics/${statistics.mailingLinkId}`}
            >
              {statistics.displayLinkName}
            </LinkWithoutPrefetch>
            {statistics.type === ClickLinkTypeEnum.AttachedFile && (
              <i>{t('dashboard.email_statistics.table_links.link_type.attachment_title')}</i>
            )}
          </div>
        </Tooltip>
      ),
    },
    {
      key: 'total clicks',
      header: t('dashboard.email_statistics.table_links.headers.total_clicks'),
      widthPercent: 15,
      onRender: statistics => (
        <span>
          {getPercentAndAmountStatistic({
            numberOfActions: statistics.totalClickAmount,
            totalNumber: totalClicksForTheEmail,
          })}
        </span>
      ),
    },
    {
      key: 'unique clicks',
      header: t('dashboard.email_statistics.table_links.headers.unique_clicks'),
      widthPercent: 15,
      onRender: statistics => (
        <span>
          {getPercentAndAmountStatistic({
            numberOfActions: statistics.uniqueClickAmount,
            totalNumber: totalClicksForTheEmail,
          })}
        </span>
      ),
    },
  ]
}
